import { render } from "./SummaryIcon.vue?vue&type=template&id=029963ee"
import script from "./SummaryIcon.vue?vue&type=script&lang=js"
export * from "./SummaryIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__